import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onBeforeUnmount } from 'vue';
import { ElLoading } from 'element-plus';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: ['id', 'dstyle'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;
const showModal = ref(false);
const store = useDonationFormsStore();

let loadingInstance: ReturnType<typeof ElLoading.service> | null = null;
let safetyTimeout: any = null;

const closeLoader = () => {
	if (loadingInstance) {
		loadingInstance.close();
		loadingInstance = null;
	}
	if (safetyTimeout) {
		clearTimeout(safetyTimeout);
		safetyTimeout = null;
	}
};

const onClick = () => {
	if (showModal.value) return;
	showModal.value = true;

	// Fullscreen ElLoading until the dialog actually opens.
	loadingInstance = ElLoading.service({
		fullscreen: true,
		lock: true,
		background: 'rgba(255, 255, 255, 0.85)',
	});

	// Safety net: if getData() fails or never resolves, drop the loader and
	// unmount the modal so the user isn't stuck.
	safetyTimeout = setTimeout(() => {
		if (!store.showModal) {
			showModal.value = false;
			closeLoader();
		}
	}, 15000);
};

const onClose = () => {
	showModal.value = false;
	closeLoader();
	if (typeof jQuery !== 'undefined') {
		jQuery('html').removeClass('modalOpen');
	}
};

// As soon as the dialog actually opens, close the loader.
watch(
	() => store.showModal,
	(val) => {
		if (val) closeLoader();
	}
);

onBeforeUnmount(closeLoader);

const __returned__ = { props, showModal, store, get loadingInstance() { return loadingInstance }, set loadingInstance(v) { loadingInstance = v }, get safetyTimeout() { return safetyTimeout }, set safetyTimeout(v) { safetyTimeout = v }, closeLoader, onClick, onClose }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})